import { FilterProtocolOverrideDTO } from "../DTO/filterProtocolOverrideDTO";
import { ValidationProtocolOverrideDTO } from "../DTO/validationProtocolOverrideDTO";
import { FieldDefinition } from "./fieldDefinition";
import { ValidationOverride } from "./moovStepConfiguration";
import { ValidationProtocol } from "./validationProtocol";
import { ValidationRule } from "./validationRule";
import { ValidationRuleDefinition } from "./validationRuleDefinition";

export class ValidationProtocolOverride{
    public sequenceNo!: number;
    public validationRules!: ValidationRule[];
    public validationOr!: boolean;

    public validationInfo:string='';

    //only used for UI purposes=>do not serialize
    public validationProtocol!: ValidationProtocol;

    constructor(){
        this.validationRules = new Array();
    }

    public relateValidationRuleDefinitionsAndFieldDefinitions(validationRuleDefinitions:ValidationRuleDefinition[], fieldDefinitions:FieldDefinition[]){
        this.validationRules.forEach(vr=>{
            vr.validationRuleDefinition=validationRuleDefinitions.find(vrd=>vrd.id==vr.validationRuleDefinitionId)!;
            vr.createInputField(fieldDefinitions);
            this.validationInfo += vr.inputField?.name + '; ';
        });
    }

    public updateValidationInfo(){
        this.validationRules.forEach(vr=>{
            this.validationInfo += vr.inputField?.name + '; ';
        });
    }

    get validationOverrideJSON(){
        return JSON.stringify(ValidationProtocolOverride.mapToDTO(this));
    }

    get validationOverrideData(){
        let validationOverride = new ValidationOverride();
        validationOverride.protocolId=this.validationProtocol?.id;
        validationOverride.value=this.validationOverrideJSON;
        return validationOverride;
    }

    get inputFieldNames():string[]{
        //in lower case for duplicate comparison
        return this.validationRules.map(vr=>vr.inputField.name.toLowerCase());
    }

    public static mapFromDTO(param:ValidationProtocolOverrideDTO):ValidationProtocolOverride{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ValidationProtocolOverride();
        try
        {
            obj.sequenceNo = param.sequenceNo;
            obj.validationOr = param.validationOr;
            obj.validationRules = param.validationRules.map(vr=>ValidationRule.mapFromDTO(vr));
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:ValidationProtocolOverride):ValidationProtocolOverrideDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ValidationProtocolOverrideDTO();
        try
        {
            dto.sequenceNo = param.sequenceNo;
            dto.validationOr = param.validationOr;
            dto.validationRules = param.validationRules.map(vr=>ValidationRule.mapToDTO(vr));
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}